import { ROUTE_DASHBOARD } from '@/constants/routes';
import { useQueryStringParam } from '@/hooks/useQueryStringParam';
import { getPath } from '@/router/utils';
import { push, canGoBack, back } from 'redux-first-router';

/**
 * From edit -> returnPath
 * From create -> returnPath
 * Fresh reload -> returnPath
 * Fresh reload & no returnPath & has prev page in the stack -> prev page
 * Fresh reload & no returnPath -> dashboard
 */
export const useNarrativeBack = () => {
  const { getItem } = useQueryStringParam();
  const returnPath = getItem('returnPath');

  const goBack = () => {
    if (returnPath) {
      push(returnPath);
    } else if (canGoBack()) {
      back();
    } else {
      push(
        getPath({
          type: ROUTE_DASHBOARD,
          payload: {},
        })
      );
    }
  };

  return {
    goBack,
    returnPath,
  };
};
